// extracted by mini-css-extract-plugin
export default {"title":"L_-z","warning":"M_-z","sizeOptionsLegendText":"N_-z"};